import React from 'react';
import './index.css';

const Hill = (props) => {
  return (
      <div id="hill">
        <svg
          width={1310.933}
          height={351.214}
          viewBox="0 0 346.851 92.925"
        >
          <path
            d="M143.837 8.36c-2.86-3.592-8.126-4.251-11.76-3.547 4.329-1.495 9.21-1.317 12.523 1.647-.126-3.16-2.12-5.191-4.03-6.46 3.534.696 4.358 3.552 5.227 6.586 1.602-1.551 1.198-4.229 1.198-6.08 1.069 2.274 1.2 4.55.545 6.84.205-2.07 1.562-3.216 2.286-3.8-1.427 1.353-1.513 2.385-1.306 4.307 1.346-1.877 2.478-2.304 4.137-2.787-1.962.91-2.496 2.389-3.157 3.927z"
            fill="#1b906a"
            strokeWidth={0.32}
          />
          <path
            d="M1.794 91.522C36.44 35.59 114.446-10.22 188.35 14.414c19.543 6.515 49.993-1.997 68.955 7.484 30.32 15.16 65.986 48.881 87.13 70.025z"
            fill="#00c1a6"
            stroke="#000"
            strokeWidth={2}
          />
          <g transform="translate(127.479 -46.117) scale(.35931)">
            <path
              d="M276.263 183.05c4.355-11.918 1.152-20.102-3.525-28.587"
              fill="none"
              stroke="#1b906a"
              strokeWidth={2.359}
              strokeLinecap="round"
            />
            <path
              d="M272.738 154.463c11.63-12.728-9.948-20.361-6.987-11.361 1.52 4.616 5.802 6.856 6.987 11.36z"
              fill="#ff8080"
              strokeWidth={0.147}
            />
            <path
              d="M272.738 154.463c15.483 7.405 16.176-15.737 8.594-10.168-3.889 2.856-4.71 7.667-8.594 10.168zM272.738 154.463c-3.888 16.89 18.593 12.706 11.622 6.37-3.575-3.25-8.39-3.05-11.622-6.37z"
              fill="#ff8080"
              strokeWidth={0.147}
            />
            <path
              d="M272.738 154.463c-17.022 1.867-5.691 21.975-2.092 13.216 1.846-4.492.067-9.03 2.092-13.216z"
              fill="#ff8080"
              strokeWidth={0.147}
            />
            <path
              d="M272.738 154.463c-7.572-15.555-22.33 2.126-12.973 2.544 4.8.215 8.396-3.034 12.973-2.544z"
              fill="#ff8080"
              strokeWidth={0.147}
            />
            <ellipse
              ry={5.378}
              rx={4.948}
              cy={154.641}
              cx={272.754}
              fill="#ffe400"
              strokeWidth={4.624}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M72.722 31.944c.468-3.742-2.287-6.815-4.967-10.09 1.703 2.98 2.695 6.467 2.95 10.245-1.316-7.015-8.44-12.36-13.195-16.299 4.166 4.486 7.363 10.95 8.072 17.075-2.673-3.5-5.45-6.31-8.693-7.606 3.11 3.206 6.758 7.103 7.762 10.866zM267.309 41.267c-2.636-5.378-8.574-8.238-13.873-9.486 6.898-.972 12.404 3.598 15.429 7.62-1.205-3.45-3.72-6.203-5.847-9.031 4.732 1.987 5.692 6.78 7.295 10.329.852-3.318.835-4.776-.888-7.067 3.312 3.635 4.305 6.952 1.919 10.818z"
            fill="#1b906a"
            strokeWidth={0.265}
            strokeLinejoin="round"
          />
          <path
            d="M189.85 53.177c-2.86-3.592-8.126-4.251-11.76-3.547 4.329-1.495 9.21-1.317 12.523 1.647-.125-3.16-2.12-5.191-4.03-6.46 3.534.696 4.358 3.552 5.227 6.586 1.602-1.551 1.198-4.229 1.198-6.08 1.069 2.274 1.201 4.55.545 6.84.205-2.07 1.562-3.216 2.286-3.8-1.427 1.353-1.513 2.385-1.306 4.307 1.346-1.877 2.478-2.304 4.137-2.786-1.962.91-2.496 2.388-3.157 3.926z"
            fill="#1b906a"
            strokeWidth={0.32}
          />
        </svg>
      </div>
  );
};

export default Hill;



// WEBPACK FOOTER //
// ./src/components/Hill/index.js